<template>
  <div class="view box grow">
    <page-headers
        :header="'Allowlist'"
        :breadcrumbs="breadcrumbs"
        :is-border="true"
        documentation="page-allowlist"
        class="box"
    >
    </page-headers>
    <div class="full-height" v-loading="rulesAllowlistReqStatus === 'loading'">
      <div class="table-toolbar" v-if="rulesAllowlistReqStatus === 'saved' && checkboxeshandler">
        <table-toolbar
            :key="allowlistRecords.key"
            :search-properties="visibleAllowlistColumns"
            :total-search-properties="allowlistColumns"
            :search-data="allowlistRecords"
            :initial-tags="allowlistRecords.searchTags"
            :active-filter-data="activeFiltersData"
            :reload-component="allowlistRecords.reloadToolbar"
            :disable-search-box="disableSearchBox"
            @update-querydata="updateTableQueryData"
            @refresh-tabledata="refreshTableData"
            @update-columns-data="modifyColumnsData"
            @add-searchtags="addSearchTags"
            @deactivate-filter="deactivateFilter"
        >
          <div slot="left-toolbar-tools" class="filter-button-group">
            <span v-if="filterList.length">
              <div class="display-inline mr-18 relative-pos" v-for="(btn, index) in filterList" :key="index">
                <el-input
                    ref="customFilterInput"
                    class="filter-input"
                    v-if="btn.editFlag"
                    placeholder="+Name"
                    v-model="btn.name"
                    @change.native.stop="handleFilterNameChange(btn)"
                    @keyup.native.enter="handleFilterNameChange(btn)"
                    @blur="handleFilterNameChange(btn)"
                ></el-input>
                <el-button
                    v-else
                    size="small"
                    round
                    :class="{'active': btn.active}"
                    :id="btn.id"
                    @click="changeState(btn)"
                >
                  {{ btn.name }}
                  <el-tooltip class="item" effect="dark" content="Edit or Delete" placement="bottom">
                  <span>
                    <i class="el-icon-edit el-icon--right" @click.stop="editFilter(btn)"></i>
                    <i class="el-icon-close el-icon--right" @click.stop="removeBtnFromList(btn, index)"></i>
                  </span>
                  </el-tooltip>
                </el-button>

                <span v-if="btn.errFlag" class="filter-name-validator">{{ filterErrMsg }}</span>
              </div>
            </span>
          </div>
          <div slot="search-actions" class="search-actions-flex">
            <el-button @click="loadDocumentation('page-allowlist')">User Guide</el-button>
            <el-button type="primary" @click="openAllowlistDialogue" class="bold">
              Add to Allowlist
            </el-button>
          </div>
        </table-toolbar>
      </div>

      <expandable-table-element
          v-if="rulesAllowlistReqStatus === 'saved'"
          :key="recordsKey"
          :columns="visibleAllowlistColumns"
          :table-data="allowlistRecords"
          :height-offset="260"
          ref="allowlistTable"
          @update-record-count="recordCountHandler"
          @delete-allowlist="handleAllowlistDelete"
      ></expandable-table-element>

      <div class="allowlist-bg" v-if="rulesAllowlistReqStatus === 'saved' && !allowlistRecords.models.length">
        <img src="/static/images/No_Allowlist.svg" alt="No Allowlist"/>
        <div class="allowlist-txt">
          <div class="bold">No Allowlist yet</div>
          <div>
            Confluera makes it quick and easy to set up rules and conditions for policy exceptions.
          </div>
          <br/>
          <div>To reduce the number of flagged detections add to allowlist.</div>
        </div>
      </div>
    </div>
    <allowlist-form v-model="allowlistDialogVisible" @create-success="refreshTableData"></allowlist-form>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {allowlistMetaInfo} from '@/column-header/allowlist/allowlist-meta'

import PageHeaders from '@/components/layout/PageHeaders.vue'
import TableToolbar from '@/components/table/TableToolbar.vue'
import ExpandableTableElement from '@/components/table/ExpandableTableElement.vue'
import AllowlistTranslationItem from '@/components/card/AllowlistTranslationItem.vue'
import AllowlistForm from '@/components/form/allowlist/AllowlistForm.vue'
import loadDocumentationMixin from '@/mixins/loadDocumentationMixin'
import customFilterMixin from '@/mixins/customFilterMixin'

import {
  ALLOWLIST_REQ,
  ALLOWLIST_REQ_SUCCESS,
  ALLOWLIST_DELETE_REQ,
  ALLOWLIST_VIEW_PREFERENCES_REQ,
  SAVE_ALLOWLIST_VIEW_PREFERENCES
} from '@/store/modules/rules/rules.type'
import {PREFERENCE_STORE_REQ} from '@/store/modules/column-preference/column-preference.type'

export default {
  name: 'Allowlist',
  mixins: [loadDocumentationMixin, customFilterMixin],
  data() {
    return {
      allowlistColumnPrefs: {},
      tableName: "Allowlist",
      breadcrumbs: [{title: 'POLICY'}, {title: 'Allow List'}],
      apiCalled: false,
      allowlistColumns: allowlistMetaInfo.meta.columns,
      visibleAllowlistColumns: [],
      allowlistRecords: {},
      openedAllowlist: [],
      allowlistDialogVisible: false,
      allowlistTypeOptions: [
        {title: 'Program', value: 'program'},
        {title: 'Network', value: 'network'},
        {title: 'File', value: 'file'}
      ],
      deletedAllowlistIds: [],
      recordsKey: true,
      checkboxeshandler: false,
      tblId: 11
    }
  },
  methods: {
    handleChange(val) {
      console.log(val)
    },
    removeAllowlist(id) {
      this.$store.dispatch(ALLOWLIST_DELETE_REQ, id).then(resp => {
        this.callApi()
      })
    },
    callApi(tableMetaData) {
      this.apiCalled = true
      this.$store.dispatch(ALLOWLIST_REQ).then(resp => {
        this.allowlistRecords = this.rulesAllowlist;

        // updating allowlistRecords with last edited allowlist
        if (_.has(this.lastEditedAllowlist, 'id')) {
          for (let record of this.allowlistRecords.models) {
            if (record.id === this.lastEditedAllowlist.id) {
              record.allowListType = this.lastEditedAllowlist.allowListType
              record.author = this.lastEditedAllowlist.author
              record.conditions = this.lastEditedAllowlist.conditions
              record.description = this.lastEditedAllowlist.description
              record.name = this.lastEditedAllowlist.name
              record.rules = this.lastEditedAllowlist.rules
              record.type = this.lastEditedAllowlist.allowListType
              break;
            }
          }
        }

        // remove entries from deletedAllowlistIds if not present in api response
        this.deletedAllowlistIds.forEach((id, index) => {
          let isPresent = false;
          this.allowlistRecords.models.forEach(record => {
            if (record.id === id) {
              isPresent = true;
            }
          })
          if (!isPresent) {
            this.deletedAllowlistIds.splice(index, 1);
          }
        })
        this.filterAllowlistRecords();

        this.$store.dispatch(ALLOWLIST_REQ_SUCCESS)
        this.setTableMetaData(tableMetaData)
        this.apiCalled = false
      })
    },
    openAllowlistDialogue(allowlistType) {
      // this.allowlistDialogVisible = true
      this.$router.push({
        name: 'create-allowlist'
      })
    },
    updateTableQueryData() {
      if (this.$refs['allowlistTable']) {
        this.$refs['allowlistTable'].updateTableData()
      }
    },
    recordCountHandler() {
      // key is used to re-render TableToolbar component
      // on page change to update 'queryCountText'
      this.allowlistRecords.key = !this.allowlistRecords.key
      this.allowlistRecords.reloadToolbar = false
    },
    modifyColumnsData(selectedColumns) {
      this.allowlistColumnPrefs.userId = this.userProfile.id;
      this.allowlistColumnPrefs.tblName = this.tableName;
      this.allowlistColumnPrefs.preferedCols = selectedColumns.length === 0 ? NaN : selectedColumns;
      this.allowlistColumnPrefs.tblId = 11; // For Mapping with database tables

      this.visibleAllowlistColumns = this.allowlistRecords.updateVisibleColumns(this.allowlistColumns, selectedColumns)

      // store preferences in db
      this.$store.dispatch(SAVE_ALLOWLIST_VIEW_PREFERENCES, this.allowlistColumnPrefs)
          .then(data => {
            // store preferences in vuex
            this.allowlistColumnPrefs.preferedCols = this.visibleAllowlistColumns;
            this.$store.dispatch(PREFERENCE_STORE_REQ, this.allowlistColumnPrefs);
          })
    },
    setTableMetaData(tableMetaData) {
      this.allowlistRecords.searchTags = tableMetaData.searchTags
      this.allowlistRecords.currentPage = tableMetaData.activePage
    },
    refreshTableData(tableMetaData) {
      if (!_.isUndefined(tableMetaData)) {
        tableMetaData.activePage = 1;
      }
      this.callApi(tableMetaData)
    },
    loadAllowlistColumnPreferences() {
      // check if already present in store
      if (_.has(this.userPref, this.userProfile.id) && _.has(this.userPref[this.userProfile.id], this.tableName)) {
        //  read values from store
        this.visibleAllowlistColumns = this.userPref[this.userProfile.id][this.tableName]
        this.checkboxeshandler = true
        // this.updateStoreWithPrefs()
      } else {
        // fetch from database
        this.$store.dispatch(ALLOWLIST_VIEW_PREFERENCES_REQ, this.userProfile.id)
            .then(data => {
              this.visibleAllowlistColumns = this.allowlistColumns.filter(col => {
                return this.allowlistPreferences.includes(col.label)
              })
              this.updateStoreWithPrefs()
              this.checkboxeshandler = true
            })
      }
    },
    updateStoreWithPrefs() {
      this.allowlistColumnPrefs = {
        userId: this.userProfile.id,
        tblName: this.tableName,
        preferedCols: this.visibleAllowlistColumns
      }

      this.$store.dispatch(PREFERENCE_STORE_REQ, this.allowlistColumnPrefs);
    },
    handleAllowlistDelete(id) {
      this.deletedAllowlistIds.push(id);
      this.filterAllowlistRecords();
    },
    filterAllowlistRecords() {
      this.allowlistRecords.models = this.allowlistRecords.models.filter((record, idx) => {
        return !this.deletedAllowlistIds.includes(record.id);
      })
      this.recordsKey = !this.recordsKey;
    }
  },
  created() {
    let tableMetaData = {
      activePage: 1,
      searchTags: []
    }
    this.callApi(tableMetaData)
    this.loadAllowlistColumnPreferences()
  },
  computed: {
    selectedRulesDropdown() {
      return _.filter(this.combineRules, {selected: true})
    },
    queryRuleResults() {
      this.markRulesVisible(this.ruleSearch)
      return this.combineRules
    },
    ...mapGetters([
      'rulesAllowlistReqStatus',
      'rulesAllowlist',
      'rulesListReqStatus',
      'allRulesList',
      'lastEditedAllowlist',
      'allowlistPreferences',
      'userProfile',
      'userPref'])
  },
  components: {
    PageHeaders,
    TableToolbar,
    ExpandableTableElement,
    AllowlistTranslationItem,
    AllowlistForm
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';

.table-toolbar {
  button {
    max-height: 36px;
  }
}

.error {
  text-align: center;
  color: var(--text-color-danger);
}

.el-dialog__wrapper {
  overflow: unset;
}

.el-dialog__wrapper >>> .el-dialog__body {
  overflow: auto;
  height: 400px;
}

.icon-text-button {
  background: var(--main-blue);
  padding: 5px 10px;

  span {
    .c-icon {
      color: white;
      font-size: 1.2em;
      vertical-align: text-bottom;
      margin-right: 5px;
    }

    span {
      color: white;
      margin-bottom: 6px;
    }
  }
}

.help-text-button {
  line-height: 28px;
  padding: 0px;
}

.material-icons {
  vertical-align: middle;
  color: var(--gray-500);
}

>>> .el-dialog__body {
  .el-select {
    width: 100%;
  }

  .el-dropdown {
    width: 100%;
    box-sizing: border-box;
    background-color: white;
    background-image: none;
    border: none;

    .el-select {
      color: var(--border-color);
      border: 1px solid var(--border-color);
      opacity: 0.8;
      height: 40px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 660px;

      &:focus,
      &.focusing {
        border-color: #409eff;
        outline: 0;
      }

      > span {
        padding-left: 10px;
      }

      > i {
        padding-right: 10px;
      }
    }

    .el-icon-arrow-down {
      vertical-align: bottom;
      line-height: 40px;
      margin-right: 24px;
    }
  }
}

.icon-arrow-down {
  mask-repeat: no-repeat;
  mask-size: cover;
  vertical-align: middle;
  line-height: 36px;
  height: 14px;
  width: 14px;
  margin-top: 10px;
}

.icon-skull,
.icon-star,
.icon-file-upload {
  display: inline-block;
  vertical-align: middle;
  mask-repeat: no-repeat;
  mask-size: cover;
  margin: 0px 5px;
}

.icon-skull,
.icon-star {
  height: 14px;
  width: 14px;
}

.icon-skull {
  background: var(--main-amaranth);
}

.icon-star {
  background: var(--main-blue);
}

.el-dropdown-link .material-icons {
  line-height: 40px;
}

.el-dropdown_footer {
  padding: 10px 20px 10px;
  border: 1px solid var(--border-color);

  .material-icons {
    line-height: 26px;
    border: 1px solid var(--border-color);
  }

  .el-col {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 500px;
  }
}

.el-divider--vertical {
  margin: 0px;
}

.search-select-dropdown {
  >>> .el-input__inner {
    border-radius: 0px;
  }

  >>> .el-dropdown-menu__item {
    padding: 0px;

    > div {
      border: 1px solid var(--border-color);
      border-top: 0px;
    }

    &:hover {
      background-color: #f5f7fa;
      color: inherit;
    }

    &.row-selected {
      background: var(--denim-50) !important;
    }

    > span {
      vertical-align: middle;
    }

    .description {
      max-width: 600px;
      word-break: break-word;
      line-height: 20px;
    }

    .el-row {
      padding: 0px 20px;

      &.row-drawer {
        background: white;
      }
    }

    .el-col-19 {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
}

.row-border {
  border: 1px solid var(--border-color);

  &.list-row {
    border-bottom: 0px;
  }
}

.image-upload {
  .icon-file-upload {
    background: var(--gray-500);
  }

  #ruleset_file {
    z-index: 99;
    opacity: 0;
    height: 20px;
    position: relative;
    left: -120px;
    cursor: pointer;
  }
}

.custom-value-search {
  >>> .el-input__inner {
    border-radius: 0px;
    border-bottom: 0px;
  }

  .material-icons {
    line-height: 40px;
  }
}

.el-form-item:not(.is-error) {
  .custom-value-input {
    >>> .el-input__inner,
    >>> .el-textarea__inner {
      font-family: var(--main-font-family);
      border: 1px solid var(--border-color);
      border-radius: 0px;
      word-break: keep-all;
    }
  }
}

.el-form-item.is-error {
  .custom-value-input {
    >>> .el-input__inner,
    >>> .el-textarea__inner {
      font-family: var(--main-font-family);
      border-radius: 0px;
      word-break: keep-all;
    }
  }
}

.custom-value-input {
  &.el-row {
    padding-top: 10px;
  }

  .add-button {
    line-height: 25px;

    .material-icons {
      font-size: 1.5em;
      vertical-align: middle;
    }
  }
}

.helper-action.icon-text-button {
  width: 100%;
  background: white;
  color: var(--denim-600);
  padding: 0px 10px;

  i,
  span {
    color: var(--denim-600);
  }
}

.clear-input {
  cursor: pointer;
  margin-left: 8px;
}

.list-row {
  >>> .el-input__inner {
    border: none;
  }
}

>>> .el-collapse-item__header {
  height: 40px;
  line-height: 40px;
  background-color: var(--gray-50);
  border-bottom: 1px solid var(--border-color);
  padding-left: 15px;
  font-size: 10px;
  font-weight: normal;
  color: inherit;
  line-height: 32px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

>>> .el-collapse-item__content {
  padding-top: 15px;
}

.allowlist-bg {
  position: absolute;
  width: 97%;
  top: 290px;
  height: 60vh;
  overflow-y: scroll;
  margin-top: 48px;

  img {
    width: 100%;
  }

  .allowlist-txt {
    position: absolute;
    top: 213px;
    right: 115px;
    width: 255px;
    height: 160px;
  }
}

.filter-button-group {
  .el-button {
    background-color: white;
    color: var(--gray-800);
    margin-bottom: 25px;

    &.active {
      background-color: var(--denim-600);
      color: white;
    }
  }

  >>> .el-input {
    input {
      border-radius: 20px;
      width: 102px;
      height: 37px;
    }
  }
}

.filter-input {
  display: table-cell;
}

>>> .search-box-container {
  position: relative;
  right: 5%;
}

.filter-name-validator {
  position: absolute;
  top: 34px;
  left: 3px;
  color: red;
  width: 110px;
}

.relative-pos {
  position: relative;
}

.search-actions-flex {
  display: flex;
  flex-wrap: nowrap;
  width: max-content;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/Allowlist.vue